import config from '../../config';

export enum ModuleNames {
  KSV = 'ksv',
  SHORE_PAY = 'shorepay',
  EVENT_MANAGER = 'eventmanager',
  CUSTOMER_DISPLAY = 'customerdisplay',
  BEEP = 'beep',
}

interface ModuleUrl {
  dev: string;
  prod: string;
  staging: string;
}

type ModuleUrlMap = Record<ModuleNames, ModuleUrl>;

const moduleUrlMap: ModuleUrlMap = {
  ksv: {
    dev: '/ksv/api',
    prod: 'https://ksv.inventorum.com/api',
    staging: 'https://ksv-aws.inventorum.com/api',
  },
  shorepay: {
    dev: '/pay/api',
    prod: 'https://payapi.shore.com/api',
    staging: 'https://payapi-staging.shore.com/api',
  },
  eventmanager: {
    dev: '/em',
    prod: 'https://pos-event-manager.shore.com',
    staging: 'https://pos-event-manager-staging.shore.com',
  },
  customerdisplay: {
    dev: '/cd/cd/api',
    prod: 'https://customer-display.shore.com/cd/api',
    staging: 'https://customer-display-staging.shore.com/cd/api',
  },
  beep: {
    dev: '/beep',
    prod: 'wss://beep.inventorum.com/connection/websocket',
    staging: 'wss://beep-aws.inventorum.com/connection/websocket',
  },
};

export const getPrefixUrl = (moduleName: ModuleNames): string => {
  if (config.IN_DEV) {
    return moduleUrlMap[moduleName].dev;
  }
  if (config.IN_PRODUCTION) {
    return moduleUrlMap[moduleName].prod;
  }
  return moduleUrlMap[moduleName].staging;
};

export const getBeepWebSocketUrl = (): string => {
  if (config.IN_DEV) {
    // For development, use the Vite proxy URL with ws protocol
    return `ws://${window.location.hostname}:5173/beep`;
  }
  // For production and staging, use the URLs from moduleUrlMap
  return getPrefixUrl(ModuleNames.BEEP);
};
